import { Platform } from "~/ui/primitives"
import { css } from "~/ui/styled"

/** Web 端输入框：默认可见边框，聚焦时高亮 */
export const webInputStyles = css<{
  error?: boolean
  isFocus?: boolean
  theme: { colors: { border: string; danger: string; primary: string; blockBackground: string } }
}>`
  height: 48px;
  padding: 0 14px;
  background-color: #cccccc1c;
  ${({ theme, error, isFocus }) =>
    Platform.OS === "web"
      ? css`
          outline: none;
          cursor: text;
          border-width: 1.5px;
          border-style: solid;
          border-color: ${error
            ? theme.colors.danger
            : isFocus
              ? theme.colors.primary
              : theme.colors.border};
          box-shadow: ${error
            ? `0 0 0 3px rgba(250, 82, 81, 0.12)`
            : isFocus
              ? `0 0 0 3px rgba(7, 193, 96, 0.18)`
              : "none"};
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
        `
      : css`
          border-width: 1px;
          border-color: ${error
            ? theme.colors.danger
            : isFocus
              ? theme.colors.primary
              : theme.colors.border};
        `}
`

/** Web 端实心按钮：阴影与按压反馈 */
export const webSolidButtonStyles = css<{ bg?: string; backgroundColor?: string; disabled?: boolean }>`
  ${({ bg, backgroundColor, disabled }) =>
    Platform.OS === "web" && (bg || backgroundColor) && !disabled
      ? css`
          box-shadow: 0 4px 12px rgba(7, 193, 96, 0.28);
          transition: box-shadow 0.15s ease, transform 0.1s ease, opacity 0.15s ease;
          &:hover {
            box-shadow: 0 6px 16px rgba(7, 193, 96, 0.34);
          }
          &:active {
            transform: translateY(1px);
            box-shadow: 0 2px 8px rgba(7, 193, 96, 0.22);
          }
        `
      : ""}
`
